import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import IconButton from './IconButton';

// Use a class-based component so that we can store a ref to the selected cell.
class WildlifeSpeciesCell extends Component {

  render() {
    return (
      <div
        ref={this.props.inputRef}
        className="WildlifeSpeciesCell"
      >
        <IconButton
          styleName="WildlifeSpeciesCell__button"
          onClick={this.props.onClick}
        >
          <p className={classNames("WildlifeSpeciesCell__title", {
              "WildlifeSpeciesCell__title--selected": this.props.selected,
            })}
          >
            {this.props.name}
          </p>
        </IconButton>
      </div>
    );
  }
}

WildlifeSpeciesCell.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default WildlifeSpeciesCell;



// WEBPACK FOOTER //
// ./src/components/WildlifeSpeciesCell.js